var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowDownToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.38298 18.617 0 12 0C5.38298 0 0 5.38298 0 12C0 18.617 5.38298 24 12 24C18.617 24 24 18.617 24 12ZM11.293 15.707L6.29302 10.707C6.09802 10.512 6 10.256 6 9.99998C6 9.744 6.09802 9.48797 6.29302 9.29297C6.684 8.90198 7.31602 8.90198 7.707 9.29297L12 13.586L16.293 9.29302C16.684 8.90203 17.316 8.90203 17.707 9.29302C18.098 9.684 18.098 10.316 17.707 10.707L12.707 15.707C12.316 16.098 11.684 16.098 11.293 15.707Z",
    fill: "#141B3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownToggle);
export default __webpack_public_path__ + "static/media/IconArrowDownToggle.47bb8fd1ec7df7edb55a6c7815ee9c33.svg";
export { ForwardRef as ReactComponent };